import React from "react";
import useFetch from "../hooks/useFetch";

// Дефолтный контент из макета — используется, пока в CMS не создан single-type "when"
// («Когда звать нас»). Пока эндпоинта нет, запрос вернёт 403/404 и отработает фолбэк.
const DEFAULT_TITLE_START = "Когда нужен";
const DEFAULT_TITLE_ACCENT = "внешний продуктовый офис";
const DEFAULT_ITEMS = [
  {
    id: "d1",
    Label: "Разбор продуктовых развилок",
    Text: "Формулируем гипотезы, проверяем их в полном цикле и по данным решаем, что масштабировать, что дорабатывать, а что закрывать",
  },
  {
    id: "d2",
    Label: "Запуск новых продуктов и направлений",
    Text: "Берём на себя стратегию, разработку, юридическую и финансовую архитектуру, когда основная команда занята текущим продуктом",
  },
];

// Однобуквенные слова («в», «и», «а») не оставляем висеть в конце строки:
// привязываем к следующему слову неразрывным пробелом.
const glueShortWords = (text) =>
  typeof text === "string"
    ? text.replace(/(^|\s)([а-яёa-z])\s+(?=\S)/gi, "$1$2\u00a0")
    : text;

export default function WhenSection() {
  const whenFetch = useFetch(`${window.$host}/api/when?populate=*`);

  // Пока фетч не settled — не рендерим ничего: тот же риск пересортировки
  // карточек между дефолтом и данными CMS, что и в ExpertiseSection.
  if (whenFetch.loading) return null;

  const cms =
    !whenFetch.error && whenFetch.data
      ? whenFetch.data.data
      : null;

  const titleStart = cms?.TitleStart || DEFAULT_TITLE_START;
  const titleAccent = cms?.TitleAccent ?? DEFAULT_TITLE_ACCENT;
  const items = cms?.Items && cms.Items.length ? cms.Items : DEFAULT_ITEMS;

  return (
    <section className="when" id="when">
      <div className="container">
        <div className="h-100 when__box">
          <h2 className="title-3 when__title">
            {titleStart}{" "}
            <span className="when__title-accent">{titleAccent}</span>
          </h2>
          <ul className="when__list">
            {items.map((item) => (
              <li key={item.id} className="when-item">
                <h3 className="when-item__label">{glueShortWords(item.Label)}</h3>
                <p className="when-item__text">{glueShortWords(item.Text)}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
